<template>
  <div>
    <div>
      <v-overlay v-model="$store.state.LoaderC">
        <div class="timer">
          <svg viewBox="0 0 200 200" width="200" height="200">
            <circle
              cx="100"
              cy="100"
              r="90"
              id="pink-halo"
              fill="none"
              stroke="#fd256e"
              stroke-width="10"
              stroke-dasharray="0, 565"
              transform="rotate(-90,100,100)"
            />
            <text
              id="myTimer"
              text-anchor="middle"
              x="100"
              y="115"
              style="font-size: 40px; fill: #343434"
            ></text>
          </svg>
        </div>
      </v-overlay>

      <!-- <v-dialog
        v-model="$store.state.LoaderC"
        hide-overlay
        persistent
        width="300"
        content-class="transparent-dialog"
      >
        <div class="timer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            viewBox="0 0 300 300"
            preserveAspectRatio="none"
            style="width: 300; height: 300; top: 0; left: 0"
          >
            
            <circle
              cx="100"
              cy="100"
              r="57"
              id="pink-halo"
              fill="none"
              stroke="#fd256e"
              stroke-width="10"
              stroke-dasharray="0, 361"
              transform="rotate(-90,100,100)"
            />
            <text
              id="myTimer"
              text-anchor="middle"
              x="100"
              y="110"
              style="font-size: 40px; fill: #343434"
            ></text>
          </svg>
        </div>
      </v-dialog> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      default: "Fetching data",
    },
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
  watch: {
    "$store.state.LoaderC"(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.startCounter();
        });
      }
    },
  },
  methods: {
    startCounter() {
      const circle = document.getElementById("pink-halo");
      const myTimer = document.getElementById("myTimer");

      const duration = 40; // countdown duration in seconds
      const interval = 30; // interval between updates in ms
      let elapsed = 0;
      let angle = 0;
      const totalIntervals = (duration * 1000) / interval;
      const angleIncrement = 360 / totalIntervals;

      window.timer = setInterval(() => {
        elapsed++;
        angle += angleIncrement;

        // Update stroke progress
        if (circle) {
          circle.setAttribute("stroke-dasharray", `${angle}, 361`);
        }

        // Update countdown text
        if (myTimer) {
          const remaining = Math.ceil(duration - (elapsed * interval) / 1000);
          myTimer.innerHTML = remaining;
        }

        // Stop when full circle is complete
        if (elapsed >= totalIntervals) {
          clearInterval(window.timer);
        }
      }, interval);
    },

    // startCounter() {
    //   const circle = document.getElementById("pink-halo");
    //   const myTimer = document.getElementById("myTimer");

    //   const duration = 30; // seconds
    //   const interval = 30; // ms
    //   let elapsed = 0;
    //   let angle = 0;
    //   const totalIntervals = (duration * 1000) / interval;
    //   const angleIncrement = 360 / totalIntervals;

    //   // Clear previous timer if any
    //   if (window.timer) clearInterval(window.timer);

    //   window.timer = setInterval(() => {
    //     elapsed++;
    //     angle += angleIncrement;

    //     if (circle) {
    //       circle.setAttribute("stroke-dasharray", `${angle}, 361`);
    //     }

    //     if (myTimer) {
    //       const remaining = Math.ceil(duration - (elapsed * interval) / 1000);
    //       myTimer.innerHTML = remaining;
    //     }

    //     if (elapsed >= totalIntervals) {
    //       clearInterval(window.timer);
    //     }
    //   }, interval);
    // },
  },
};

// export default {
//   props: {
//     message: {
//       default: "Fetching data",
//     },
//   },
//   computed: {
//     getThemeColor() {
//       return this.$store.getters.getThemeColor;
//     },
//   },
//   mounted() {
//     this.startCounter();
//   },
//   methods: {
//     startCounter() {
//       const circle = document.getElementById("pink-halo");
//       const myTimer = document.getElementById("myTimer");

//       const duration = 60; // seconds
//       const interval = 30; // ms
//       let elapsed = 0;
//       let angle = 0;
//       const totalIntervals = (duration * 1000) / interval;
//       const angleIncrement = 360 / totalIntervals;

//       // Start the timer
//       window.timer = setInterval(() => {
//         elapsed++;
//         angle += angleIncrement;

//         // Update the stroke to simulate circular progress
//         if (circle) {
//           circle.setAttribute("stroke-dasharray", `${angle}, 361`);
//         }

//         // Update the countdown display
//         if (myTimer) {
//           const remaining = Math.ceil(duration - (elapsed * interval) / 1000);
//           myTimer.innerHTML = remaining;
//         }

//         // Stop when full circle is reached
//         if (elapsed >= totalIntervals) {
//           clearInterval(window.timer);
//         }
//       }, interval);
//     },
//   },
// };
</script>

<style scoped>
.circle-only-dialog {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  border: none !important;
  border-radius: 100%;
  overflow: visible !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100vw !important;
  height: 100vh !important;
  position: fixed !important;
  top: 0;
  left: 0;
  z-index: 9999;
}

.timer {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  height: 100;
  width: 100;
  border-radius: 100%;
}
/* .circle-only-dialog {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  overflow: visible !important;
  border: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.timer {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  background: transparent;
  pointer-events: none;
} */

.transparent-dialog {
  background: transparent !important;
  box-shadow: none !important;
}

/* .timer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background: transparent;
} */

#myTimer {
  font-size: 40px;
  fill: #343434;
}

/* .timer {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ccc;
  height: 100%;
  width: 100%;
} */
</style>
